import { createComponentRegistry, lazyWithPreload } from 'copilot-toolkit/js/custom-components';
const TYPES = {
  GOOGLE_FILE_PICKER: 'GOOGLE_FILE_PICKER'
};
const BreezeGoogleFilePicker = lazyWithPreload(() => import( /* webpackChunkName: "data-integrations-breeze" */'./BreezeGoogleFilePicker'));
export const dataIntegrationsBreezeRegistryEntry = createComponentRegistry('DATA_INTEGRATIONS', {
  GOOGLE_FILE_PICKER: BreezeGoogleFilePicker
});
export { TYPES as DATA_INTEGRATIONS_TYPES };